import React from 'react';
import TranscriptDisplay from './TranscriptDisplay';

export default function TranscriptTab({ segments, loading, highlight, transcriptReferences }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 session-transcript-panel">
      <div className="p-5 max-h-[600px] overflow-y-auto">
        <TranscriptDisplay
          segments={segments}
          loading={loading}
          highlightRef={highlight}
          transcriptReferences={transcriptReferences}
        />
      </div>
    </div>
  );
}
